import script from "./WhatsAppCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppCampaigns.vue?vue&type=style&index=0&id=79770914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79770914"]])

export default __exports__